<template>
<div>
  <modal-cadastro-disciplina-itinerario-formativo/>
  <section-definition title="Itinerários" event-update="atualizarItinerarioFormativo"></section-definition>
  <v-toolbar dark color="primary" class="text-xs-center">
      <v-toolbar-title>Gerenciar Cadastro de Itinerários Formativos</v-toolbar-title>
      <v-divider class="mx-2" inset vertical></v-divider>
  </v-toolbar>
  <v-container fluid>
    <v-layout wrap>
      <v-flex xs12 sm6 md6>
        <v-text-field color="primary" disabled v-model="this.$store.getters.user.instituicao"></v-text-field>
      </v-flex>
      <v-flex xs12 sm6 md3>
        <v-select v-model="idCurso" item-text="nome" item-value="id" :items="cursos" label="Curso"
        @change="atualizarNomeCursoEIdNivel(idCurso)"></v-select>
      </v-flex>
    </v-layout>
    <v-layout wrap  v-if="idCurso">
      <v-flex xs12 sm2 md2>
        <v-subheader v-if="idCurso">Itinerários Formativos</v-subheader>
      </v-flex>
      <v-flex xs12 sm2 md1>
        <modal-cadastro-itinerario-formativo :id-curso="idCurso"
        :nome-curso="nomeCurso" :id-nivel="idNivel" @itinerarioFormativoCadastrado="cadastroEfetuado = $event"></modal-cadastro-itinerario-formativo>
      </v-flex>
      <v-flex xs12 sm2 md12>
        <v-data-table :loading="loading" :headers="headers" :items="itinerariosFormativos" class="elevation-1" :total-items="pagination.totalItems" :pagination.sync="pagination">
          <template slot="items" slot-scope="props">
            <td>{{ props.item.nome }}</td>
            <td>{{ props.item.sigla }}</td>
            <td>{{ props.item.dataInicioVigencia }}</td>
            <td>{{ props.item.dataFinalVigencia }}</td>
            <td>{{ props.item.ativo | booleanFilter }}</td>
            <td>
              <v-menu offset-y>
                <v-btn slot="activator" title="Opções itinerários formativos" color="primary" dark><v-icon>keyboard_arrow_down</v-icon>Opções</v-btn>
                <v-list>
                  <v-list-tile alt="Editar" @click="editar(props.item)">
                    <v-list-tile-title>
                      <v-icon medium class="mr-2">
                        edit
                      </v-icon>
                      Editar
                    </v-list-tile-title>
                  </v-list-tile>
                  <v-divider></v-divider>
                  <v-list-tile alt="Excluir" @click="excluir(props.item)">
                    <v-list-tile-title>
                      <v-icon medium class="mr-2">
                        delete
                      </v-icon>
                      Excluir
                    </v-list-tile-title>
                  </v-list-tile>
                  <v-divider></v-divider>
                  <v-list-tile alt="Disciplinas do Itinerário Informativo" @click="abrirCadastroDisciplinaItinerarioFormativo(props.item)">
                    <v-list-tile-title>
                      <v-icon medium class="mr-2">
                        playlist_add_check
                      </v-icon>
                      Disciplinas
                    </v-list-tile-title>
                  </v-list-tile>
                </v-list>
              </v-menu>
            </td>
          </template>
          <template slot="no-data">
            Não existem informações cadastradas!
          </template>
        </v-data-table>
      </v-flex>
    </v-layout>
  </v-container>
</div>
</template>
<script>
import cursoService from "@/service/curso/CursoService";
import itinerarioFormativoService from "@/service/itinerario/ItinerarioFormativoService";
import ItinerarioFormativo from "@/model/itinerario/ItinerarioFormativo";
import Pagination from "@/utils/Pagination.js";
import ModalCadastroItinerarioFormativo from "./ModalCadastroItinerarioFormativo";
import ModalCadastroDisciplinaItinerarioFormativo from "./ModalCadastroDisciplinaItinerarioFormativo";
import EventBus from "@/utils/EventBus.js";
import { booleanFilter } from "@/filters/Filters.js";

export default {
  name: "GerenciaCadastroItinerariosFormativos",
  components: {
    ModalCadastroItinerarioFormativo,
    ModalCadastroDisciplinaItinerarioFormativo
  },
  filters: {
    booleanFilter: booleanFilter
  },
  data() {
    return {
      dialog: false,
      idCurso: null,
      nomeCurso: "",
      cursos: [],
      itinerariosFormativos: [],
      itinerarioFormativo: new ItinerarioFormativo(),
      pagination: new Pagination(1, 5),
      loading: true,
      cadastroEfetuado: false,
      headers: [
        {
          text: "Nome",
          align: "left",
          sortable: false,
          value: "nome"
        },
        {
          text: "Sigla",
          align: "left",
          sortable: false,
          value: "sigla"
        },
        {
          text: "Data Inicio Vigência",
          align: "left",
          sortable: false,
          value: "dataInicioVigencia"
        },
        {
          text: "Data Final Vigência",
          align: "left",
          sortable: false,
          value: "dataFinalVigencia"
        },
        {
          text: "Ativo",
          align: "left",
          sortable: false,
          value: "ativo"
        },
        { text: "", value: "name", sortable: false }
      ]
    };
  },
  watch: {
    cadastroEfetuado(event) {
      if (event) {
        setTimeout(() => {
          this.pesquisar();
          this.cadastroEfetuado = false;
        }, 500);
      }
    },
    pagination: {
      handler() {
        this.pesquisar();
      }
    }
  },
  created() {
    this.carregarDadosBasicos();
    this.atualizar();
    EventBus.$on("atualizarItinerarioFormativo", async () => {
      this.atualizar();
    });
  },
  methods: {
    abrirCadastroDisciplinaItinerarioFormativo(itinerarioFormativo) {
      EventBus.$emit("abrirCadastroDisciplinaItinerarioFormativo", this.idCurso, this.nomeCurso, itinerarioFormativo);
    },
    atualizarNomeCursoEIdNivel(id) {
      const arrayCurso = this.cursos.filter(c => {
        return c.id === id;
      });
      this.nomeCurso = arrayCurso[0].nome;
      this.idNivel = arrayCurso[0].idNivel;
      this.atualizar();
    },
    editar(itinerarioFormativo) {
      EventBus.$emit("editaItinerarioFormativo", itinerarioFormativo.id);
    },
    excluir(itinerarioFormativo) {
      confirm("Você deseja realmente excluir o Itinerário Formativo?") &&
      itinerarioFormativoService.excluir(itinerarioFormativo).then(() => {
          this.itinerariosFormativos.splice(this.itinerariosFormativos.indexOf(itinerarioFormativo), 1);
          this.atualizar();
        });
    },
    atualizar() {
      this.pesquisar();
    },
    async pesquisar() {
      if (this.idCurso) {
        this.itinerarioFormativo.idCurso = this.idCurso;
        this.loading = true;
        const paginacaoResultado = await itinerarioFormativoService.listarTodos(
          this.itinerarioFormativo,
          this.pagination.page,
          this.pagination.rowsPerPage
        );
        this.itinerariosFormativos = paginacaoResultado.dados;
        this.pagination.totalItems = paginacaoResultado.total;
        this.loading = false;
      }
    },
    async carregarDadosBasicos() {
      this.cursos = await cursoService.combo();
    }
  }
};
</script>
